import { decryptToken } from "../lib/decryptAuth";
import { setToken } from "../services/storageService";

let bootstrapPromise: Promise<string | undefined> | null = null;

function hasUrlAuthTransferParam(): boolean {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.has("auth") || params.has("token");
}

function stripAuthParamsFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("auth") && !params.has("token")) return;
  params.delete("auth");
  params.delete("token");
  const newSearch = params.toString();
  const newUrl =
    window.location.pathname + (newSearch ? `?${newSearch}` : "") + window.location.hash;
  window.history.replaceState({}, "", newUrl);
}

/**
 * Resolves `?auth=` / `?token=` from login-auth redirect once per page load.
 * Skipped on /auth/callback — completeLoginFromRedirect handles that path.
 */
export function ensureUrlAuthBootstrap(): Promise<string | undefined> {
  if (!bootstrapPromise) {
    bootstrapPromise = resolveUrlAuth();
  }
  return bootstrapPromise;
}

async function resolveUrlAuth(): Promise<string | undefined> {
  if (typeof window === "undefined") return undefined;

  if (!hasUrlAuthTransferParam()) {
    return undefined;
  }

  let bearer: string | undefined;
  const params = new URLSearchParams(window.location.search);
  const authParam = params.get("auth");
  const tokenParam = params.get("token");

  if (authParam?.trim()) {
    const secret = (process.env.REACT_APP_AUTH_SECRET ?? "").trim();
    if (secret) {
      try {
        bearer = await decryptToken(authParam.trim(), secret);
      } catch {
        // Decrypt failed; session cookie may still work.
      }
    }
  } else if (tokenParam?.trim()) {
    bearer = tokenParam.trim();
  }

  stripAuthParamsFromUrl();

  if (bearer) {
    setToken(bearer);
  }

  return bearer;
}
